import { Action, createReducer, on } from '@ngrx/store';
import { SuggestedParty } from '@wdx/clmi/clmi-swagger-gen';
import { CrudState, CrudStateObject } from '@wdx/clmi/api-services/models';
import * as suggestedPartiesActions from './suggested-parties.actions';

export interface State {
    suggestedParties: CrudStateObject<SuggestedParty>;
}

export const initialState: State = {
    suggestedParties: {},
};

const reducerSetup = createReducer(
    initialState,

    on(
        suggestedPartiesActions.getForParty,
        (state, props): State => ({
            ...state,
            suggestedParties: {
                ...state.suggestedParties,
                [props.partyId]: {
                    ...(state.suggestedParties[props.partyId] ||
                        ({} as CrudState<SuggestedParty>)),
                    isLoadingList: true,
                    hasLoadingListError: false,
                },
            },
        }),
    ),

    on(
        suggestedPartiesActions.getForPartySuccess,
        (state, props): State => ({
            ...state,
            suggestedParties: {
                ...state.suggestedParties,
                [props.partyId]: {
                    ...state.suggestedParties[props.partyId],
                    isLoadingList: false,
                    hasLoadingListError: false,
                    list: props.suggestedParties,
                },
            },
        }),
    ),

    on(
        suggestedPartiesActions.getForPartyFailure,
        (state, props): State => ({
            ...state,
            suggestedParties: {
                ...state.suggestedParties,
                [props.partyId]: {
                    ...state.suggestedParties[props.partyId],
                    isLoadingList: false,
                    hasLoadingListError: true,
                },
            },
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
